import { userRole } from '@/config/constants';

const roleGuard = (meta) => meta.dispatch(roleGuardAction(meta));

const roleGuardAction = (meta) => (_dispatch, getState) => {
	const state = getState();
	const user = state.auth.profile;

	if (Array.isArray(meta?.allowedRoles) && meta.allowedRoles.length > 0) {
		const hasAllowedRole = user?.role?.some((role) => 
			meta.allowedRoles.includes(role.name)
		);

		if (!hasAllowedRole) {
			return '/';
		}
	}

	return null;
}

export { roleGuard, userRole }
